module.exports = __webpack_public_path__ + "static/saleways-781f143796abd30441c90ab69f211a28.png";